import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import PaymentForm from "./PaymentForm";
import { stripePublicKey } from "../../config";

const stripeTestPromise = stripePublicKey ? loadStripe(stripePublicKey) : null;

function StripeContainer({
  setUserPack,
  userData,
  setCart,
  cart,
}) {
  return (
    <div className="container">
      <Elements stripe={stripeTestPromise}>
        <PaymentForm
          setUserPack={setUserPack}
          userData={userData}
          setCart={setCart}
          cart={cart}
        />
      </Elements>
    </div>
  );
}

export default StripeContainer;
